export default {
  "/": {
    title: "中思拓研究院",
    desc: "促进决策科学化，为社会创造新价值",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/home": {
    title: "中思拓研究院",
    desc: "促进决策科学化，为社会创造新价值",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/researchlist/dataReport": {
    title: "研究成果 - 中思拓研究院",
    desc: "市场监测与预警报告|常规报告",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/researchlist/subjectReport": {
    title: "研究成果 - 中思拓研究院",
    desc: "常规报告|专题报告",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/researchlist/warnReport": {
    title: "研究成果 - 中思拓研究院",
    desc: "市场监测与预警报告|常规报告",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  // "/mobile/newslist": {
  //   title: "新闻活动 - 中思拓研究院",
  //   img:
  //     "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  // },
  "/mobile/newslist/newslist": {
    title: "新闻活动 - 中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/newslist/hotnewlist": {
    title: "媒体热评 - 中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/bigNewList": {
    title: "大事件 - 中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/dataServe/dataInsight": {
    title: "数据服务 - 中思拓研究院",
    desc: "数据洞察 | 房屋智能估价 | 定制化",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },

  "/mobile/dataServe/collateral": {
    title: "数据服务 - 中思拓研究院",
    desc: "数据洞察 | 房屋智能估价 | 定制化",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },

  "/mobile/dataServe/customization": {
    title: "数据服务 - 中思拓研究院",
    desc: "数据洞察 | 房屋智能估价 | 定制化",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/customization": {
    title: "定制化 - 中思拓研究院",
    // desc: "数据洞察 | 房屋智能估价 | 定制化",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/dataInsight": {
    title: "数据服务 - 中思拓研究院",
    // desc: "数据洞察 | 房屋智能估价 | 定制化",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/collateral": {
    title: "房屋智能估价 - 中思拓研究院",
    // desc: "数据洞察 | 房屋智能估价 | 定制化",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/about": {
    title: "关于我们 - 中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
  },
  "/mobile/details": {},
  "/mobile/dataView": {
    title: "中思拓研究院数据确权可视化大屏",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
    desc: "中思拓研究院数据确权可视化大屏",

  },
  "/mobile/solution": {
    title: "解决方案-中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
    desc: "解决方案",
  },
  "/mobile/solution1": {
    title: "解决方案-中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
    desc: " 房屋智能估价的解决方案 ",
  },
  "/mobile/solution2": {
    title: "解决方案-中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
    desc: " 数据服务的解决方案 ",
  },
  "/mobile/solution3": {
    title: "解决方案-中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
    desc: " 住房市场监测及预警的解决方案  ",
  },
  "/mobile/solution4": {
    title: "解决方案-中思拓研究院",
    img:
      "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
    desc: " 地址数据治理的解决方案 ",
  },






};
